module.exports = __webpack_public_path__ + "static/media/YM58_3.5c844848.jpg";